import { render, staticRenderFns } from "./ListInitial.vue?vue&type=template&id=59ef2a6d&scoped=true&"
import script from "./ListInitial.vue?vue&type=script&lang=js&"
export * from "./ListInitial.vue?vue&type=script&lang=js&"
import style0 from "./ListInitial.vue?vue&type=style&index=0&id=59ef2a6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef2a6d",
  null
  
)

export default component.exports